/**
 * Runs a re-render of `container` and gives keyboard focus back to the control that had it (matched by data-focus).
 * Views rebuild their filters and rows on every state change; without this a keyboard user would be dropped out of
 * the page each time they pressed a button. If the control no longer exists, focus goes to `fallback`.
 */
export function keepFocus(container: HTMLElement, render: () => void, fallback?: HTMLElement | null) {
  const active = document.activeElement instanceof HTMLElement && container.contains(document.activeElement) ? document.activeElement.dataset.focus : undefined;
  render();
  if (!active) return;
  const target = Array.from(container.querySelectorAll<HTMLElement>("[data-focus]")).find((n) => n.dataset.focus === active);
  (target ?? fallback)?.focus();
}
